import Intl from 'intl'

/* eslint-disable import/no-internal-modules */
import 'intl/locale-data/jsonp/en-GB'

export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24

const formatDateInLocalTimezone = (timestamp, showTime = true) => {
  const format = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }

  if (showTime) {
    format.hour = '2-digit'
    format.minute = '2-digit'
  }

  return (
    new Intl.DateTimeFormat('en-GB', format).format(timestamp * 1000)
  )
}

export default formatDateInLocalTimezone
